import { APP_PERMISSIONS } from '@exam-management/permissions';
import { DuplicateQBankStructureModal } from '@exam-management/qbank-structure-duplication';
import {
  Box,
  Flex,
  IconButton,
  ContentCopyRoundedIcon,
  AssignmentOutlinedIcon,
  Menu,
  MenuItem,
  MoreVertIcon,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { WithPermission } from '@shared/permissions';
import { useState } from 'react';

interface MoreActionButtonProps {
  qBankStructureId: string;
  name: string;
  onCompleted: () => Promise<void>;
}

export default function MoreActionButton(props: Readonly<MoreActionButtonProps>) {
  const { name, qBankStructureId, onCompleted } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isDuplicateModalOpen, duplicateModalHandlers] = useDisclosure(false);
  const { open: openDuplicateModal, close: closeDuplicateModal } = duplicateModalHandlers;
  const isOpen = anchorEl !== null;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    // TODO: handle closing Menu [See history]
    // Apply logic here ...
    setAnchorEl(null);
  };

  const handleCloseDuplicateModal = () => {
    closeDuplicateModal();
  };

  const handleClickDuplicateMenu = () => {
    openDuplicateModal();
    handleCloseMenu();
  };

  const handleCompleted = async () => {
    await onCompleted?.();
    closeDuplicateModal();
  };

  return (
    <Box>
      <IconButton
        aria-label='more'
        id='long-button'
        aria-controls={isOpen ? 'long-menu' : undefined}
        aria-expanded={isOpen ? 'true' : undefined}
        aria-haspopup='true'
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id='long-menu'
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleCloseMenu}
      >
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(1) }}>
          <WithPermission requiredPermission={APP_PERMISSIONS.QBANK.STRUCTURE.CREATE}>
            <MenuItem onClick={handleClickDuplicateMenu}>
              <ContentCopyRoundedIcon sx={{ marginRight: '4px', width: '24px', height: '24px' }} />
              Duplicate
            </MenuItem>
          </WithPermission>
          <MenuItem onClick={handleCloseMenu}>
            <AssignmentOutlinedIcon sx={{ marginRight: '4px', width: '24px', height: '24px' }} />
            ดูประวัติการเปลี่ยนแปลง
          </MenuItem>
        </Flex>
      </Menu>
      <DuplicateQBankStructureModal
        qBankStructureId={qBankStructureId}
        open={isDuplicateModalOpen}
        name={name}
        onClose={handleCloseDuplicateModal}
        onCompleted={handleCompleted}
      />
    </Box>
  );
}
